import { colors, spacing } from "@procore/core-react";

export const HEADER_BORDER = `1px solid ${colors.gray90}`;

/** Inset between the viewer container edge and a Window's draggable bounds. */
export const VIEWER_INSET = spacing.sm;

/** Horizontal and vertical padding used by SlottedWindow's header rows. Match this in body content to align with the header. */
export const SLOTTED_WINDOW_HEADER_PADDING = spacing.lg;

/**
 * Marks the title row inside `.window-header`, which also wraps the subheader rows (tabs,
 * search). Styling and test hook only — the mobile drawer finds the row it measures for its
 * collapsed peek through `DrawerPeekTargetContext`, not through this class.
 */
export const WINDOW_HEADER_ROW_CLASS = "window-header-row";
